/* Builder A · WF-12 Défi d’équipe shared bits. No new CSS. */
import { Link } from 'react-router-dom'
import { Skeleton } from '@/ui'

export const Retour = () => (
  <p className="f-help" style={{ margin: 0 }}><Link to="/equipe/defi">‹ Défi d’équipe</Link></p>
)

export const Chargement = () => (
  <div style={{ display: 'grid', gap: 10, maxWidth: 720 }}>
    <Skeleton width="42%" /><Skeleton /><Skeleton width="65%" />
  </div>
)
